import { render, staticRenderFns } from "./SetDomainStatusWidget.vue?vue&type=template&id=723eaa90"
import script from "./SetDomainStatusWidget.vue?vue&type=script&lang=js"
export * from "./SetDomainStatusWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports